import React, { useContext, useEffect, useState } from "react";
import { CategoryContext } from "./CategoryContext";
import CategoryList from "./CategoryList";
import AddEditViewCategoryType from "./AddEditViewCategoryType";
import AddEditViewCategory from "./AddEditViewCategory";
import { AppContext } from "../../../Context/AppContext";
import AssociatedAttributes from "./components/AssociatedAttributes";
import AssociatedRules from "./components/AssociatedRules";
import RelevantCategories from "./components/RelevantCategories";
import PdwAttributeOrder from "./components/PdwAttributeOrder";
import AbsAttributeOrder from "./components/AbsAttributeOrder";
import CategoryAttributeConstraint from "./components/CategoryAttributeConstraint";
import Label from "../../Common/components/Label";
import SkeletonElement from "./Shimmer/SkeletonElement";
import { toast } from "react-toastify";
import { Link, useHistory } from "react-router-dom";
import VariantDefiningAttributes from "./components/VariantDefiningAttributes";
import { ABS_ATTRIBUTES, ACCORDION_FLUSH_ABS, ACCORDION_FLUSH_CF, ACCORDION_FLUSH_COLLAPSE_ABS, ACCORDION_FLUSH_COLLAPSE_CF, CF_ATTRIBUTES } from "./CategoryConstants";

function CategoryTypeManage(props) {
  const appData = useContext(AppContext);
  const industryId =
    appData.get_selected_industry() && appData.get_selected_industry().id;
  let { editingItem, setEditingItem, deleteinfo } = useContext(CategoryContext);
  let [categoryName, setCategoryName] = useState("");
  let [categoryTypeName, setCategoryTypeName] = useState("");
  let [apiCallDone, setApiCallDone] = useState(false);
  const history = useHistory();
  let [categoryDetailPageLoaded, setCategoryDetailPageLoaded] = useState(false);
  const [showShimmer, setShowShimmer] = useState(true);

  const [reRender, setReRender] = useState(true);

  useEffect(() => {
    if (editingItem && editingItem.id !== 0) setReRender(false);
    setTimeout(() => {
      setReRender(true);
    }, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingItem && editingItem.id]);

  useEffect(() => {
    setEditingItem(null);

    if (
      props.props &&
      props.props.match.params &&
      props.props.match.params.type
    ) {
      if (props.props.match.params.type === "ct") {
        if (props.props.match.params.uid) {
          setEditingItem({
            type: "ct",
            form: "view",
            id: props.props.match.params.uid,
          });
        } else {
          setEditingItem({
            type: "ct",
            form: "edit",
            id: "0",
          });
        }
      }
      if (props.props.match.params.type === "c") {
        if (props.props.match.params.uid) {
          setEditingItem({
            type: "c",
            form: "view",
            id: props.props.match.params.uid,
          });
        } else {
          setEditingItem({
            type: "c",
            form: "edit",
            id: "0",
            category_type_id: undefined,
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [industryId]);

  const categoryContextData = useContext(CategoryContext);

  return (
    <React.Fragment>
      <div className="container-fluid p-0">
        <div className="row mt-0 pt-0 ">
          <div className="col-md-3">
            {deleteinfo.status === "Loading" && (
              <div
                className="alert alert-primary bg-white small p-1"
                role="alert"
              >
                <span className="fas fa-circle-notch fa-spin" />
                &nbsp;
                <strong>{deleteinfo.message}</strong>
              </div>
            )}
            {deleteinfo.status === "Success" && (
              <div
                className="alert alert-primary bg-white small p-1"
                role="alert"
              >
                <span className="fa fa-check" />
                &nbsp;
                <strong>{deleteinfo.message}</strong>
              </div>
            )}
            {deleteinfo.status === "Error" && (
              <div
                className="alert alert-danger bg-white small p-1"
                role="alert"
              >
                <span className="fa fa-exclamation-triangle" />
                &nbsp;
                <strong>{deleteinfo.message}</strong>
              </div>
            )}
          </div>
        </div>

        <div className="d-flex flex-wrap">
          <div
            className="col-sm-12 col-md-12 col-lg-2 relative md:h-page-content p-0 top-0"
            style={{ borderRight: "2px solid #e6e6e6" }}
          >
            <CategoryList
              props={props}
              setApiCallDone={setApiCallDone}
              setCategoryDetailPageLoaded={setCategoryDetailPageLoaded}
            />
          </div>

          {editingItem === null && apiCallDone && (
            <div className="col-sm-12 col-md-12 col-lg-10 ps-0 pe-0">
              <div className="card-body text-dark text-center ">
                <div className="default-page mt-5">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/img/place_holder_no_data.svg"
                    }
                    alt="logo"
                    className="tw-m-auto"
                    style={{
                      width: "auto",
                      height: "160px",
                      color: "#091caa",
                    }}
                  />
                  <br />
                  <Label
                    message="No data found"
                    fontSize={"2"}
                    fontWeight="600"
                    color="#091caa"
                  />
                  <br />
                  <Label
                    message="You can create category for the products."
                    fontSize={"0.75"}
                    fontWeight="500"
                  />
                  <br />
                  <br />
                  <div
                    className=" btn-group"
                    style={{
                      right: "6px",
                    }}
                  >
                    <button
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      className="button-outlined"
                    >
                      Create Category
                    </button>

                    <ul className={`dropdown-menu`}>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item"
                          onClick={() => {
                            if (
                              appData.pm.checkPermission("gmscategory_create")
                            ) {
                              categoryContextData.setEditingItem({
                                type: "ct",
                                form: "edit",
                                id: "0",
                              });
                            } else {
                              toast.success(
                                "You don't have permission to create the category type"
                              );
                            }
                          }}
                          style={{ fontSize: ".8rem" }}
                          href="#"
                        >
                          Category Type
                        </Link>
                      </li>
                      {12 > 0 && (
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item"
                            style={{ fontSize: ".8rem" }}
                            onClick={() => {
                              if (
                                appData.pm.checkPermission("gmscategory_create")
                              ) {
                                categoryContextData.setEditingItem({
                                  type: "c",
                                  form: "edit",
                                  id: "0",
                                  category_type_id: undefined,
                                });
                              } else {
                                toast.info(
                                  "You don't have permission to create the category"
                                );
                              }
                            }}
                            href="#"
                          >
                            Category
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="col-sm-12 col-md-12 col-lg-10 md:h-page-content w-full p-0">
            <div className="md:overflow-y-auto md:max-h-full">
              {editingItem !== null &&
                editingItem !== undefined &&
                editingItem.type === "ct" && (
                  <>
                    <AddEditViewCategoryType />
                  </>
                )}

              {editingItem !== null &&
                editingItem !== undefined &&
                editingItem.type === "c" && (
                  <>
                    <AddEditViewCategory
                      categoryName={categoryName}
                      setCategoryName={setCategoryName}
                      categoryTypeName={categoryTypeName}
                      setCategoryTypeName={setCategoryTypeName}
                      setCategoryDetailPageLoaded={setCategoryDetailPageLoaded}
                      showShimmer={showShimmer}
                      setShowShimmer={setShowShimmer}
                    />
                    {editingItem.id !== "0" && reRender && (
                      <div
                        className="ms-2 ps-1"
                        style={{ marginBottom: "50vh" }}
                      >
                        {categoryDetailPageLoaded ? (
                          <div>
                            <AssociatedAttributes />
                            <br />
                            <VariantDefiningAttributes />
                            <br />
                            <AssociatedRules />
                            <br />
                            <RelevantCategories />
                            <br />
                            <PdwAttributeOrder />
                            <br />
                            <AbsAttributeOrder title={ABS_ATTRIBUTES} id={'Abs'} />
                            <br />
                            <CategoryAttributeConstraint />
                            <br />
                            <AbsAttributeOrder title={CF_ATTRIBUTES} id={'CF'} />

                          </div>
                        ) : (
                          <div>
                            {showShimmer && (
                              <div>
                                <br />
                                <SkeletonElement type={"text"} />
                                <br />
                                <SkeletonElement type={"title"} />
                                <br />
                                <SkeletonElement type={"title"} />
                                <br />
                                <SkeletonElement type={"title"} />
                                <br />
                                <SkeletonElement type={"title"} />
                                <br />
                                <SkeletonElement type={"title"} />
                                <br />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default CategoryTypeManage;
